import { get } from 'dpl/shared/utils/object';

import { MAX_COLUMNS } from '../utils/constants';

export function normalizeTable(rows) {
  const emptyColumns = new Set(
    Array.from(Array(MAX_COLUMNS), (_, idx) => `col${idx + 1}`)
  );

  const { length: rowLength } = rows;
  for (let rowIdx = 0; rowIdx < rowLength; rowIdx++) {
    const row = rows[rowIdx];
    const columns = Object.entries(row);
    const { length: colLength } = columns;

    for (let colIdx = 0; colIdx < colLength; colIdx++) {
      const [name, value] = columns[colIdx];
      if (get(value, '0.text')) {
        emptyColumns.delete(name);
      }
    }
  }

  const normalizedTable = [];

  rows.forEach(row => {
    const columns = Object.entries(row);
    const normalizedRow = [];
    let hasContent;
    columns.forEach(([name, value]) => {
      if (!emptyColumns.has(name)) {
        normalizedRow.push(value);
        hasContent = true;
      }
    });

    if (hasContent) {
      normalizedTable.push(normalizedRow);
    }
  });

  return normalizedTable;
}
